module.exports = __webpack_public_path__ + "img/slack.5bee6e8b.svg";